module.exports = __webpack_public_path__ + "static/media/1to2.9480dd59.svg";